import { render, staticRenderFns } from "./IpsInput.vue?vue&type=template&id=51145d10&scoped=true"
import script from "./IpsInput.vue?vue&type=script&lang=js"
export * from "./IpsInput.vue?vue&type=script&lang=js"
import style0 from "./IpsInput.vue?vue&type=style&index=0&id=51145d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51145d10",
  null
  
)

export default component.exports